module.exports = __webpack_public_path__ + "img/ajax-loader.42978fcc.gif";